import React from "react"
import Image from "../components/image"

import { Link } from "gatsby"

const tagColors = {
  "Web App": "bg-teal-400",
  "Landing Page": "bg-orange-700",
}

const Card = ({ props: { title, tags, img, color, slug } }) => {
  return (
    <Link
      to={"/" + slug}
      className={`card ${color} transform hover:-translate-y-4 duration-500  pt-6 pl-6 cursor-pointer relative`}
    >
      <h3 className="font-semibold text-2xl xl::w-1/2 text-purple-900 relative z-20">
        {title}
      </h3>
      <div className="flex item-center flex-wrap xl:w-7/12 relative z-20">
        {tags.map(tag => (
          <div
            className={`px-2 h-5 flex items-center rounded-full ${tagColors[tag]} mt-2 mr-2`}
          >
            <p className="text-white" style={{ fontSize: "10px" }}>
              {tag}
            </p>
          </div>
        ))}
      </div>

      <div className="absolute bottom-0 right-0 w-56 rounded-full mb-2 mr-2">
        <Image src={img} alt={title} />
      </div>
    </Link>
  )
}

export default Card
